import { post, get, put, deleteReq } from './api';

export const fetchFolders = () => get('/folders');

export const addFolder = folder =>
  post(`/folders/`, JSON.stringify(folder), {
    'Content-Type': 'application/json',
  });

export const deleteFolder = id =>
  deleteReq(`/folders/${id.payload.id}`, {
    'Content-Type': 'application/json',
  });

export const moveFile = (folderId, fileId) =>
  put(`/folders/${folderId}/extensions/${fileId}`);

export const editFolder = ({ id, payload }) => {
  put(`/folders/${id}`, JSON.stringify(payload), {
    'Content-Type': 'application/json',
  });
};



// WEBPACK FOOTER //
// ./src/services/folderApi.js